import router from '../router'
import URLAPI from "@/libsV2/urlApi";
import storage from "@/libsV2/storage";
function objToParam (param) {
    if (Object.prototype.toString.call(param) !== '[object Object]') {
        return '';
    }
    let queryParam = '';
    for (let key in param) {
        if (param.hasOwnProperty(key)) {
            let value = param[key];
            queryParam += toQueryPair(key, value);
        }
    }
    return queryParam;
}

function toQueryPair (key, value) {
    if (typeof value == 'undefined') {
        return `/${key}/`;
    }
    return `/${key}/${value}`;
}
export default {
    //加载cdn文件
    importScript(path, success, error) {
        var oS = document.createElement('script')
        oS.type = 'module';
        oS.src = path
        document.getElementsByTagName('head')[0].appendChild(oS)
        oS.onload = function (e) {
            undefined
            success && success()
        }

        oS.onerror = function () {
            undefined
            error && error()
        }
    },
    upImgCompression(event) {
        // 压缩图片需要的一些元素和对象
        let imgArr = [];
        // 缩放图片需要的canvas
        let canvas = document.createElement('canvas');

        if (navigator.appName == "Microsoft Internet Explorer" && parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE", "")) < 10) {
            return new Promise(function (resolve, reject) {
                alert('您的浏览器版本过低，请下载最新版本');
                return [];
            })
        } else {
            // 选择的文件对象
            let file = event.target.files;
            let context = canvas.getContext('2d');
            for (let i = 0; i < file.length; i++) {

                var reader = new FileReader(),
                    imgFile = file[i];
                // 选择的文件是图片
                if (imgFile.type.indexOf("image") == 0) {
                    reader.readAsDataURL(imgFile);
                } else {
                    continue;
                }
                let img = new Image();
                // 文件base64化，以便获知图片原始尺寸
                reader.onload = function (e) {
                    img.src = e.target.result;
                };
                var imgP = new Promise(function (resolve, reject) {
                    // base64地址图片加载完毕后
                    img.onload = function () {
                        // 图片原始尺寸
                        var originWidth = this.width;
                        var originHeight = this.height;
                        // 最大尺寸限制
                        var maxWidth = 800,
                            maxHeight = 800;
                        // 目标尺寸
                        var targetWidth = originWidth,
                            targetHeight = originHeight;
                        // 图片尺寸超过400x400的限制
                        if (originWidth > maxWidth || originHeight > maxHeight) {
                            if (originWidth / originHeight > maxWidth / maxHeight) {
                                // 更宽，按照宽度限定尺寸
                                targetWidth = maxWidth;
                                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                            } else {
                                targetHeight = maxHeight;
                                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                            }
                        }
                        // canvas对图片进行缩放
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;

                        // 清除画布
                        context.clearRect(0, 0, targetWidth, targetHeight);
                        // 图片压缩
                        context.drawImage(img, 0, 0, targetWidth, targetHeight);
                        var base64 = canvas.toDataURL("image/png", 0.6);

                        resolve(base64);
                    };
                });

                imgArr.push(imgP);
            }
            // canvas,context = null;
            return Promise.all(imgArr);
        }
    },

    throttle(func, wait, options) {
        let time, context, args, result;
        let previous = 0;
        if (!options) options = {};

        let later = function () {
            previous = options.leading === false ? 0 : new Date().getTime();
            time = null;
            func.apply(context, args);
            if (!time) context = args = null;
        };

        let throttled = function () {
            let now = new Date().getTime();
            if (!previous && options.leading === false) previous = now;
            let remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (time) {
                    clearTimeout(time);
                    time = null;
                }
                previous = now;
                func.apply(context, args);
                if (!time) context = args = null;
            } else if (!time && options.trailing !== false) {
                time = setTimeout(later, remaining);
            }
        };
        return throttled;
    },
    accAdd(arg1, arg2) {
        var r1, r2, m, c;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
            var cm = Math.pow(10, c);
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""));
                arg2 = Number(arg2.toString().replace(".", "")) * cm;
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm;
                arg2 = Number(arg2.toString().replace(".", ""));
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
    },
    /**
     * 高精度减法
     * @param [arg1] 第一位。
     * @param [arg2] 第二位。
     */
    accSub(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },
    /**
     * 匹配身份证
     */
    cardIdReg: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    /**
     * 匹配手机号
     */
    phoneReg: /^1[3|4|5|6|7|8][0-9]{9}$/,
    /**
     * 获取url参数
     * @param [name] 需要获取的参数名。
     */
    getQueryString: function (name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || '';
    },
    /**
     * 微信网页h5修改网页title
     * @param [title] 需要修改的标题名。
     */
    setTitle: function (title) {
        document.title = title;
        var i = document.createElement('iframe');
        i.src = 'http://m.baidu.com/favicon.ico';
        i.style.display = 'none';
        i.onload = function () {
            setTimeout(function () {
                i.remove();
            }, 9);
        };
        document.body.appendChild(i);
    },
    /**
        * 路由跳转
        * @url 跳转路径
        * @param 传参对象形式
        * @type 跳转类型 为1时跳vue，默认不传  为2时跳php页面
        * */
    redirect: function (url, params, type = 1) {
        const ald_source = this.getQueryString('ald_source')
        if (type === 2) {
            const HREF = store.state.php_url + url +  objToParam({ald_source, ...params})
            window.location.href = HREF
        } else {
            router.push({path: url, query: {...params, ald_source}})
        }
    },
    /**
     * 事件上报
     * @param evtName
     * @param id
     */
    pushEvent: function (evtName, id) {
        let env = 0
        var ua = window.navigator.userAgent.toLowerCase();
        //判断ua和微信浏览器的标识头是否匹配
        if (ua.match(/micromessenger/i) == 'micromessenger') { // 微信浏览器
            env = 0
        } else if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) { // 企业微信
            env = 1
        }
        let imageData = {
            session_uuid: sessionStorage.getItem('uuid'),
            log: {
                track_action: evtName,
                track_uuid: sessionStorage.getItem('page_uuid'),
                track_id: id,
                page_url: encodeURIComponent(location.href),
                env: env
            }
        }

        let image = new Image();
        image.src = `${URLAPI.URL5}/comm/logs/evt?source=h5&log=${JSON.stringify(imageData.log)}`;
    },
    /**
     * 判断微信环境
     * @returns {number} 1为微信，6为企微，0为其他环境
     */
    isWechat: function () {
        var ua = window.navigator.userAgent.toLowerCase();
        //判断ua和微信浏览器的标识头是否匹配
        if ((ua.match(/micromessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) { // 微信浏览器
            return 6
        } else if (ua.match(/micromessenger/i) == 'micromessenger') { // 企业微信
            return 1
        } else { // app端访问 相当于普通h5
            return 0
        }
    }
};